import { Box, FormControl, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PaginationContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100% !important',
  maxWidth: '100% !important',
  minWidth: '100%',
  padding: theme.spacing(1.5, 1),
  minHeight: '56px',
  flexDirection: 'column',
  boxSizing: 'border-box',
  margin: 0,

  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(1, 2),
    flexDirection: 'row',
    gap: 0,
  },
}));

export const RowsPerPageContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(5),
  justifyContent: 'center',

  [theme.breakpoints.up('sm')]: {
    justifyContent: 'flex-start',
  },
}));

export const RowsPerPageLabel = styled(Typography)(({ theme }) => ({
  fontSize: '0.75rem',
  whiteSpace: 'nowrap',

  [theme.breakpoints.up('sm')]: {
    fontSize: '0.875rem',
  },
}));

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  '& .MuiSelect-select': {
    fontSize: '0.75rem',

    [theme.breakpoints.up('sm')]: {
      fontSize: '0.875rem',
    },
  },

  '&:before': {
    display: 'none',
  },

  '&:after': {
    display: 'none',
  },
}));

export const PageNavigationContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  [theme.breakpoints.up('sm')]: {
    justifyContent: 'flex-end',
  },

  '& .MuiPaginationItem-root': {
    fontSize: '0.75rem',
    minWidth: '28px',
    height: '28px',
    margin: '0 1px',

    [theme.breakpoints.up('sm')]: {
      fontSize: '0.875rem',
      minWidth: '32px',
      height: '32px',
      margin: '0 2px',
    },
  },
}));
